// @flow
import React, { Component } from 'react';
import { TabNavLink, SpacerTab } from '../../components/TabStyles';
import NavTabs from '../../components/NavTabs';
import { AccountHeaderDiv } from './AccountStyles';
import { Default } from '../../components/Responsive';
type Props = {};

export default class HeaderBlock extends Component<Props> {
  render() {
    return (
      <AccountHeaderDiv>
        <NavTabs>
          <TabNavLink exact to="/account">
            Account <Default>Information</Default>
          </TabNavLink>
          <TabNavLink to="/account/bank-account">
            Bank <Default>Account</Default>
          </TabNavLink>
          <TabNavLink to="/account/crypto-wallets">Crypto Wallets</TabNavLink>
          <SpacerTab tablet />
        </NavTabs>
      </AccountHeaderDiv>
    );
  }
}
